import React from 'react'

function ValidateInput(props) {

    let name = props.children.props.name;
    let isInvalid = props.errors.hasOwnProperty(name);
    let errorMessage = isInvalid ? props.errors[name] : '';
    return (
        isInvalid == false ?
            props.children
            :
            <>
                {React.Children.map(props.children, (child) =>
                    React.cloneElement(child, {
                        className: `${child.props.className} is-invalid`
                    })
                )
                }
                <div className="invalid-feedback">
                    {errorMessage}
                </div>
            </>
    )
}

export default ValidateInput;
